// «فایل‌های من» (تبِ +) روی همین گوشی: آگهی‌هایی که ثبت شده‌اند ولی طراحی‌شان تمام یا منتشر نشده، با نیمه‌کارِ پلان
// (editorState) و فایل‌های آماده‌ی انتشار (prepared). IndexedDB چون عکس‌ها و فیلم Blob هستند و حجمشان زیاد است.
// با عوض کردنِ تب یا بستنِ برنامه از بین نمی‌روند.

const DB_NAME = 'khoonero-drafts';
const STORE = 'drafts';

let dbPromise = null;
function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('no-idb'));
      return;
    }
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE, { keyPath: 'id' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  }).catch((e) => {
    dbPromise = null;
    throw e;
  });
  return dbPromise;
}

function tx(mode, fn) {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const t = db.transaction(STORE, mode);
        const out = fn(t.objectStore(STORE));
        t.oncomplete = () => resolve(out && out.result !== undefined ? out.result : undefined);
        t.onerror = () => reject(t.error);
        t.onabort = () => reject(t.error);
      })
  );
}

export function newDraftId() {
  return `d${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
}

// فقط چیزهای ماندنی: آدرسِ موقتِ فیلم و پیشرفتِ ارسال نه؛ «در حالِ انتشار» بعد از بازگشت = «آماده‌ی انتشار»
function clean(d) {
  const { filmUrl, progress, ...rest } = d;
  return { ...rest, status: rest.status === 'publishing' ? 'designed' : rest.status, updatedAt: Date.now() };
}

export async function loadDrafts() {
  try {
    const all = (await tx('readonly', (s) => s.getAll())) || [];
    return all.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
  } catch (e) {
    return [];
  }
}

export async function saveDraft(draft) {
  try {
    await tx('readwrite', (s) => s.put(clean(draft)));
  } catch (e) {
    // چیزی در فایل‌ها قابلِ ذخیره نبود — دستِ‌کم آگهی و پلان بماند
    try {
      await tx('readwrite', (s) => s.put(clean({ ...draft, prepared: null, status: draft.status === 'published' ? 'published' : 'draft' })));
    } catch (e2) {
      /* ذخیره روی این مرورگر ممکن نیست */
    }
  }
}

export async function deleteDraft(id) {
  try {
    await tx('readwrite', (s) => s.delete(id));
  } catch (e) {
    /* */
  }
}
